import * as React from 'react'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import { SxProps } from '@mui/system'
import { Theme } from '@mui/material/styles'

interface LoadingButtonProps {
  onClick: React.MouseEventHandler
  isLoading: boolean
  disabled?: boolean
  sx?: SxProps<Theme>
  children: React.ReactNode
}

const LoadingButton: React.FC<LoadingButtonProps> = ({ onClick, sx = {}, isLoading, children, disabled = false }) => {
  return (
    <Button
      sx={{ ...sx }}
      variant="contained"
      onClick={onClick}
      disabled={isLoading || disabled}
      startIcon={isLoading ? <CircularProgress sx={{ color: 'grey.500' }} size={16} /> : null}
    >
      {children}
    </Button>
  )
}

export default LoadingButton
